import { GlSprintf } from '@gitlab/ui';
import { s__ } from '~/locale';
import DetailsRow from '~/vue_shared/components/registry/details_row.vue';
export default {
    name: 'MetadataConan',
    i18n: {
        recipeText: s__('PackageRegistry|Recipe: %{recipe}')
    },
    components: {
        DetailsRow,
        GlSprintf
    },
    props: {
        packageMetadata: {
            type: Object,
            required: true
        }
    }
};
